module.exports = __webpack_public_path__ + "img/policy-videos.2d74127c.webp";